import React, {Component} from 'react';
import { Grid } from 'react-bootstrap';

class Footer extends Component {
	render() {
		return (
            <footer className="footer">
                <Grid>
                    <p className="copyright pull-right">
                        &copy; {(new Date()).getFullYear()} All Systems Go
                        as <a href="http://yerd.ly">YERD.LY</a>
                        <br/>
                        Proudly designed <i>by</i> yerds, <i>for</i> yerds.
                    </p>
                </Grid>
            </footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx